import Marquee from "react-fast-marquee";
import { Circle } from "@phosphor-icons/react";
import { useLang } from "../../context/LangContext";

export const EditorialMarquee = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#0A0F1A] border-y border-white/10 py-6" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {t.marquee.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-bold text-2xl md:text-3xl uppercase tracking-tight text-white/90 px-8">{word}</span>
            <Circle size={8} weight="fill" className="text-emerald-500" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};
